import React from "react";
import {renderChatMessageBody} from "./utils";

/* If onlineState is not set then nothing happens otherwise:
  - "online" => Will appear online
  - "offline" => Will appear offline
  - "loading" => a spinner is shown
*/
export default function ChatMessageTagOwnerImage({onlineState, tagOwner}) {
  let tagOwnerIcon = "fa fa-user"
  const iconStyle = {}

  if (tagOwner.moderator) {
    tagOwnerIcon = "fa fa-user-tie"
  } else if (onlineState === "offline") {
    // iconStyle["color"] = "#a0a0a0"
    tagOwnerIcon = ""
  } else if (onlineState === "loading") {
    iconStyle["color"] = "#a0a0a0"
    tagOwnerIcon = "fa fa-spinner fa-spin"
  } else if (onlineState === "online") {
    iconStyle["color"] = "#07bd0e"
    iconStyle["border"] = "1 px #A0A0A0"
    tagOwnerIcon = "fas fa-circle"
  }

  if (tagOwner.tag_owner_image_url) {
    return <div className={"direct-messaging-tag-owner-image-container"}>
      <img className={"direct-messaging-tag-owner-image"} src={tagOwner.tag_owner_image_url} />
    </div>
  }

  return <i style={iconStyle} className={tagOwnerIcon}/>
}
